import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { Container } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import ConfigUrl, { axiosbaseurl } from "../../config"
import { notification, Select } from "antd"
import { SiTicktick } from "react-icons/si"
import { IoMdWarning } from "react-icons/io"
import Loader from "pages/Loader"
import { usePermissionData } from "AppContext"
import PermittedComponent from "PermittedComponent"
import { FaChevronLeft, FaChevronRight, FaSave } from "react-icons/fa"

const { Option } = Select

const AddCustomer = () => {
  document.title = "Customers | Return First Investments"
  const { checkAccess } = usePermissionData()

  const navigate = useNavigate()

  const [Loading, setLoading] = useState(false)

  // State for storing user photo and its preview URL
  const [UserPhoto, setUserPhoto] = useState(null)
  const [UserPhotoPreview, setUserPhotoPreview] = useState(null)

  // Handle image change
  const handleImageChange = e => {
    const file = e.target.files[0]
    if (file) {
      setUserPhoto(file)
      setUserPhotoPreview(URL.createObjectURL(file)) // Generate preview URL
    }
  }

  const [user, setUser] = useState({
    UserName: "",
    Email: "",
    Phone: "",
    Password: "",
    ConfirmPassword: "",
    address: "",
    clientId: "",
    joiningDate: "",
    totalInvestedAmount: "",
    selectedTypes: null,
  })

  // Error state for validation
  const [errors, setErrors] = useState({})

  // Handle input change
  const handleChange = e => {
    const { name, value } = e.target
    setUser(prev => ({ ...prev, [name]: value }))
  }

  // Validation function
  const validate = () => {
    let tempErrors = {}
    if (!user.UserName.trim()) tempErrors.UserName = "User Name is required"
    if (!user.clientId.trim()) tempErrors.clientId = "Client ID is required"
    if (!user.address.trim()) tempErrors.address = "Address is required"
    if (!user.Email.trim()) {
      tempErrors.Email = "Email is required"
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(user.Email)) {
      tempErrors.Email = "Invalid email format"
    }
    if (!user.Phone.trim()) {
      tempErrors.Phone = "Phone number is required"
    } else if (!/^\d{10}$/.test(user.Phone)) {
      tempErrors.Phone = "Phone number must be 10 digits"
    }
    // if (!user.Password.trim()) tempErrors.Password = "Password is required"
    // if (!user.ConfirmPassword.trim()) {
    //   tempErrors.ConfirmPassword = "Confirm Password is required"
    // } else if (user.Password !== user.ConfirmPassword) {
    //   tempErrors.ConfirmPassword = "Passwords do not match"
    // }
    if (!user.joiningDate) tempErrors.joiningDate = "Joining Date is required"
    if (!user.totalInvestedAmount)
      tempErrors.totalInvestedAmount = "Initial Capital is required"
    if (user.selectedTypes .length === 0) tempErrors.selectedTypes = "Graph Type is required"
    setErrors(tempErrors)
    return Object.keys(tempErrors).length === 0
  }

  // Handle form submission
  const handleSubmit = async () => {
    if (validate()) {
      try {
        setLoading(true)

        const Formdata = new FormData()
        Formdata.append("profilePhoto", UserPhoto)
        Formdata.append("customerName", user?.UserName)
        Formdata.append("email", user?.Email)
        // Formdata.append("password", user?.Password)
        Formdata.append("contactNumber", user?.Phone)
        Formdata.append("address", user?.address)
        Formdata.append("clientId", user?.clientId)
        Formdata.append("joiningDate", user?.joiningDate)
        Formdata.append("totalInvestedAmount", user?.totalInvestedAmount)
        Formdata.append("graphTypes", JSON.stringify(user?.selectedTypes))

        const response = await axiosbaseurl.post(
          `customer-management`,
          Formdata
        )

        if (response?.data?.success) {
          setLoading(false)
          notification.open({
            message: (
              <div className="d-flex align-items-center">
                <div className="pr-20">
                  <SiTicktick className="text-success fs-4 me-2" />
                </div>
                <div className="succes-message">
                  Customer Created Successfully.
                </div>
              </div>
            ),
            placement: "topRight",
          })

          setTimeout(() => {
            navigate(`${ConfigUrl.appurl}customers`)
          }, 1000)
        } else {
          setLoading(false)
          notification.open({
            message: (
              <div className="d-flex">
                <div className="pr-10">
                  <IoMdWarning className="text-danger" size={22} />
                </div>
                <div>Opps! Something went wrong.</div>
              </div>
            ),
          })
        }
      } catch (e) {
        setLoading(false)
        notification.open({
          message: (
            <div className="d-flex">
              <div className="pr-10">
                <IoMdWarning className="text-danger" size={22} />
              </div>
              <div>Opps! Something went wrong.</div>
            </div>
          ),
          description: e?.response?.data?.message,
        })
      }
    }
  }

  const handleChange1 = value => {
    setUser(prev => ({ ...prev, selectedTypes: value }))
    console.log("Selected:", value)
  }

  return (
    <React.Fragment>
      {Loading && <Loader />}
      <PermittedComponent isAccess={checkAccess(3, 2)}>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs title="Customers" breadcrumbItem="Add Customer" />

            <div className="card p-3">
              <div className="text-end">
                <button
                  className="btn edit-Button bg-success text-white me-3 rounded-5"
                  onClick={handleSubmit}
                >
                  <FaSave className="me-2" />
                  Submit
                </button>
                <button
                  className="btn delete-Button rounded-5"
                  onClick={() => navigate(-1)}
                >
                  <FaChevronLeft className="me-2" />
                  Back
                </button>
              </div>
              <div className="Line" />

              <div className="row my-3">
                <div className="form-group col-xl-7 col-12">
                  <label>Profile Photo</label>
                  <input
                    type="file"
                    className="form-control"
                    placeholder="Enter Full name"
                    name="Profile Image"
                    accept="image/*"
                    onChange={handleImageChange}
                  />
                </div>
                {UserPhotoPreview && (
                  <div className="col-xl-1">
                    <img
                      className="Profile-img"
                      src={UserPhotoPreview}
                      alt="User Preview"
                    />
                  </div>
                )}
                <div className="form-group col-xl-4 col-12">
                  <label>
                    Graph Type <span className="text-danger">*</span>
                  </label>
                  <Select
                    mode="multiple"
                    allowClear
                    placeholder="Select grpah type(s)"
                    style={{ width: "100%" }}
                    value={user.selectedTypes}
                    onChange={handleChange1}
                    className="antd-select"
                  >
                    <Option value="long">Long Term</Option>
                    <Option value="short">Short Term</Option>
                    <Option value="trading">Trading</Option>
                  </Select>
                  {errors.selectedTypes && (
                    <span className="text-danger">{errors.selectedTypes}</span>
                  )}
                </div>

                {/* User Name */}
                <div className="form-group col-xl-6 col-12 mt-3">
                  <label>
                    Full Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Full name"
                    name="UserName"
                    value={user.UserName}
                    onChange={handleChange}
                  />
                  {errors.UserName && (
                    <span className="text-danger">{errors.UserName}</span>
                  )}
                </div>

                <div className="form-group col-xl-6 col-12 mt-3">
                  <label>
                    Client ID <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Client ID"
                    name="clientId"
                    value={user.clientId}
                    onChange={handleChange}
                  />
                  {errors.clientId && (
                    <span className="text-danger">{errors.clientId}</span>
                  )}
                </div>

                {/* Email */}
                <div className="form-group col-xl-6 col-12 mt-3">
                  <label>
                    Email <span className="text-danger">*</span>
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Enter email"
                    name="Email"
                    value={user.Email}
                    onChange={handleChange}
                  />
                  {errors.Email && (
                    <span className="text-danger">{errors.Email}</span>
                  )}
                </div>

                {/* Phone */}
                <div className="form-group col-xl-6 col-12 mt-3">
                  <label>
                    Phone <span className="text-danger">*</span>
                  </label>
                  <input
                    type="tel"
                    maxLength={10}
                    className="form-control"
                    placeholder="Enter phone number"
                    name="Phone"
                    value={user.Phone}
                    onChange={handleChange}
                  />
                  {errors.Phone && (
                    <span className="text-danger">{errors.Phone}</span>
                  )}
                </div>

                <div className="form-group col-xl-6 col-12 mt-3">
                  <label>
                    Joining Date <span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    placeholder="Enter Joining Date"
                    name="joiningDate"
                    value={user.joiningDate}
                    onChange={handleChange}
                  />
                  {errors.joiningDate && (
                    <span className="text-danger">{errors.joiningDate}</span>
                  )}
                </div>

                <div className="form-group col-xl-6 col-12 mt-3">
                  <label>
                    Initial Capital <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter total Initial Capital"
                    name="totalInvestedAmount"
                    value={user.totalInvestedAmount}
                    onChange={handleChange}
                  />
                  {errors.totalInvestedAmount && (
                    <span className="text-danger">
                      {errors.totalInvestedAmount}
                    </span>
                  )}
                </div>

                <div className="form-group col-xl-12 col-12 mt-3">
                  <label>
                    Address <span className="text-danger">*</span>
                  </label>
                  <textarea
                    type="text"
                    className="form-control"
                    placeholder="Enter address"
                    name="address"
                    value={user.address}
                    onChange={handleChange}
                  />
                  {errors.address && (
                    <span className="text-danger">{errors.address}</span>
                  )}
                </div>

                {/* Password */}
                {/* <div className="form-group col-xl-6 col-12 mt-3">
                  <label>
                    Password <span className="text-danger">*</span>
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Enter password"
                    name="Password"
                    value={user.Password}
                    onChange={handleChange}
                  />
                  {errors.Password && (
                    <span className="text-danger">{errors.Password}</span>
                  )}
                </div>

                {/* Confirm Password 
                <div className="form-group col-xl-6 col-12 mt-3">
                  <label>
                    Confirm Password <span className="text-danger">*</span>
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Confirm password"
                    name="ConfirmPassword"
                    value={user.ConfirmPassword}
                    onChange={handleChange}
                  />
                  {errors.ConfirmPassword && (
                    <span className="text-danger">
                      {errors.ConfirmPassword}
                    </span>
                  )}
                </div> */}
              </div>
            </div>
          </Container>
        </div>
      </PermittedComponent>
    </React.Fragment>
  )
}

export default AddCustomer
